"use client";

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { IContactInfo } from "@/interface/contact";
import { createContact } from "@/service/api";

interface IContactPageProps {
  innerPage: boolean;
}
const ContactForm: React.FC<IContactPageProps> = ({ innerPage = false }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IContactInfo>({
    mode: "all",
  });

  const onSubmit = async (data: IContactInfo) => {
    setIsFormLoading(true);
    try {
      const payload = {
        ...data,
        client: "hindustanpurefoods.com",
      };
      const response = await createContact(payload);

      toast.success("Enquiry sent successfully!");

      reset();
    } catch (error: any) {
      console.error("API Error:", error.message);
      toast.error("Failed to send enquiry. Try again!");
    } finally {
      setIsFormLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`rv-2-contact__form ${
        innerPage ? "rv-inner-contact__form" : ""
      }`}
    >
      <div className="row">
        {/* Name */}
        <div className="col-sm-6">
          <div className="space-y-1 position-relative pb-3">
            <input
              type="text"
              placeholder="Your Name"
              className="form-control border-1 shadow-none"
              {...register("name", {
                required: "Name is required",
              })}
            />
            {errors.name && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.name.message}
              </p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="col-sm-6">
          <div className="space-y-1 position-relative pb-3">
            <input
              type="email"
              placeholder="Email"
              className="form-control border-1 shadow-none"
              {...register("email", {
                required: "Email address is required.",
                pattern: {
                  value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                  message: "Please enter a valid email address.",
                },
              })}
            />
            {errors.email && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.email.message}
              </p>
            )}
          </div>
        </div>

        {/* Phone */}
        <div className="col-sm-6">
          <div className="space-y-1 position-relative pb-3">
            <input
              type="number"
              placeholder="Phone number"
              className="form-control border-1 shadow-none"
              onKeyDown={(event) => {
                const key = event.key;
                if (key === "e" || key === "E" || key === "." || key === "-") {
                  event.preventDefault();
                }
              }}
              {...register("phone", {
                required: "Phone number is required.",
                minLength: {
                  value: 10,
                  message: "Phone number must be at least 10 digits",
                },
                maxLength: {
                  value: 10,
                  message: "Phone number cannot exceed 10 digits",
                },
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Only numbers are allowed",
                },
              })}
            />
            {errors.phone && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.phone.message}
              </p>
            )}
          </div>
        </div>

        {/* Address */}
        <div className="col-sm-6">
          <div className="space-y-1 position-relative pb-3">
            <input
              type="text"
              placeholder="Address"
              className="form-control border-1 shadow-none"
              {...register("address", {
                required: "Address is required",
              })}
            />
            {errors.address && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.address.message}
              </p>
            )}
          </div>
        </div>

        {/* Subject */}
        <div className="col-12">
          <div className="space-y-1 position-relative pb-3">
            <select
              className="form-select border-1 shadow-none"
              defaultValue=""
              {...register("subject", {
                required: "Subject is required",
              })}
            >
              <option value="" disabled hidden>
                Select Subject
              </option>
              <option value="Project Buy">Project Buy</option>
              <option value="Custom Project">Custom Project</option>
              <option value="Partnership Offer">Partnership Offer</option>
              <option value="others">Others</option>
            </select>
            {errors.subject && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.subject.message}
              </p>
            )}
          </div>
        </div>

        {/* Message */}
        <div className="col-12">
          <div className="space-y-1 position-relative pb-3">
            <textarea
              placeholder="Message"
              rows={5}
              className="form-control border-1 shadow-none"
              {...register("message", {
                required: "Message is required",
              })}
            ></textarea>
            {errors.message && (
              <p
                className="text-danger small position-absolute mt-1 ms-1"
                style={{ fontSize: "12px" }}
              >
                {errors.message.message}
              </p>
            )}
          </div>
        </div>

        {/* Submit */}
        <div className="col-12">
          <button
            type="submit"
            disabled={isFormLoading}
            className="btn btn-primary"
            style={{ backgroundColor: "#012307", borderColor: "#012307" }}
          >
            {isFormLoading ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
